import React, { useState,useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../assets/images/ScribeSmart.png';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { loginThunk } from '../../redux/slices/login.slice';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { AppDispatch, RootState } from '../../redux/store';
import { FcGoogle } from "react-icons/fc";
import { hostConfig } from '../../config';
import { useNavigate } from 'react-router-dom';
import { FiTarget } from "react-icons/fi";
import { RxCheckCircled } from "react-icons/rx";
import Cookies from "js-cookie";




const Login: React.FC = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { isLoading,user } = useSelector((state: RootState) => state.login);
  const [isLoadingLogin,setIsLoadingLogin] = useState(false)
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  const [passwordRules, setPasswordRules] = useState({
    minLength: false,
    hasNumber: false,
    hasCharacter: false,
  });


  useEffect(() => {
    const sessionId = Cookies.get('session_id');
    const accessToken = localStorage.getItem("accessToken");
    if (sessionId && accessToken) {
      navigate('/account-settings/profile-settings');
    }
  }, []);

  useEffect(() => {
    setIsLoadingLogin( isLoading === true || ![null,undefined].includes(user) ? true : false)
  }, [user,isLoading]);

  const formik = useFormik({
    initialValues: {
      email: '',
      password: '',
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .email('Enter a valid email')
        .required('Email is required')
        .test('no-capitals', 'Email should not contain capital letters', (value) => {
          return value ? value === value.toLowerCase() : true;
        }),
      password: yup.string().required('Password is required'),
    }),
    onSubmit: async (values) => {
      await dispatch(loginThunk(values));
    },
  });

  const validatePassword = (password: string) => {
    setPasswordRules({
      minLength: password.length >= 8,
      hasNumber: /\d/.test(password),
      hasCharacter: /[A-Za-z]/.test(password)
    });
  };
  const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    formik.handleChange(e);
    validatePassword(e.target.value);
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-[#215564] to-[#163942] bg-white">
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">


        <form onSubmit={formik.handleSubmit} className="space-y-6">
          <h2 className="text-xl font-bold text-center text-gray-700">
            <img src={Logo} alt="ScribeSmart Logo" width={100} className="w-32 mx-auto mb-4" />
            </h2>
          <p className="text-center text-gray-500 !mt-0">Sign in to your account</p>

          <div>
            <label htmlFor="email" className="block text-sm font-medium text-gray-600">
              Email Address
            </label>
            <input
              name="email"
              type="email"
              placeholder="Enter your email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              className={`w-full px-4 py-2 mt-2 text-sm text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${formik.touched.email && formik.errors.email ? 'border-red-500' : 'border-gray-300'
                }`}
            />
            {formik.errors.email && formik.touched.email ? (
              <div className="mt-1 pb-2 text-sm text-red-500 text-[13px]">{formik.errors.email}</div>
            ):(
                <span>&nbsp;</span>
              )}
          </div>

          <div className='!mt-0'>
            <label htmlFor="password" className="block text-sm font-medium text-gray-600">
              Password
            </label>
            <div className="relative">
              <input
                name="password"
                type={showPassword ? 'text' : 'password'}
                placeholder="Enter your password"
                value={formik.values.password}
                onChange={handlePasswordChange}
                onBlur={formik.handleBlur}
                className={`w-full px-4 py-2 mt-2 text-sm text-gray-700 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 ${formik.touched.password && formik.errors.password ? 'border-red-500' : 'border-gray-300'
                  }`}
              />
              <span
                className="absolute right-3 top-5 text-gray-500 cursor-pointer"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <BsEye /> : <BsEyeSlash />}
              </span>
            </div>
            {formik.errors.password && formik.touched.password ? (
              <div className="mt-1 pb-2 text-sm text-red-500 text-[13px]">{formik.errors.password}</div>
            ):(
              <span>&nbsp;</span>
            )}
          </div>
          {/* Add Password Guide in list below */}
          <div className='!mt-0'>
            <ul className="mt-0  text-xs list-none">
              <li className={`mb-2 ${passwordRules.hasNumber ? 'text-green-500' : 'text-red-500'}`}>
                <span className='flex items-center'>{passwordRules.hasNumber ? <RxCheckCircled className='mr-1'/> : <FiTarget className='mr-1' />} Contains at least one number</span>
              </li>
              <li className={`mb-2 ${passwordRules.hasCharacter ? 'text-green-500' : 'text-red-500'}`}>
                <span className='flex items-center'>{passwordRules.hasCharacter ? <RxCheckCircled className='mr-1'/> : <FiTarget className='mr-1'/>} Contains at least one letter</span>
              </li>
              <li className={`mb-1 ${passwordRules.minLength ? 'text-green-500' : 'text-red-500'}`}>
                <span className='flex items-center'>{passwordRules.minLength ? <RxCheckCircled className='mr-1'/> : <FiTarget className='mr-1'/>} At least 8 characters</span>
              </li>

            </ul>
          </div>
          <button
            type="submit"
            disabled={isLoadingLogin}
            className={`w-full px-4 py-2 text-sm font-medium text-white bg-[#17BE62] rounded-lg hover:bg-[#10a452] focus:outline-none focus:ring-4 focus:ring-blue-300 ${isLoadingLogin ? 'opacity-50 cursor-not-allowed' : ''
              } !mt-[10px]`}
          >
            {isLoadingLogin ? 'Signing In...' : 'Sign In'}
          </button>

          <p className="text-center text-sm text-gray-500 !mt-[10px]">OR</p>

          <a
            href={`${hostConfig.API_URL}auth/google-login-url`}
            onClick={()=>setIsLoadingLogin(true)}
            className={`flex items-center justify-center w-full px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-300 ${ isLoadingLogin ? 'opacity-50 cursor-not-allowed pointer-events-none' : ''} !mt-[10px]`}
          >
            <FcGoogle className="w-5 h-5 mr-2" />
            {isLoadingLogin ? 'Signing in with Google...' : 'Sign in with Google'}
          </a>

          <p className="text-sm text-center text-gray-600">
            Forgot your password?{' '}
            <button
              type="button"
              onClick={() => navigate('/forgot-password')}
              className="font-medium text-blue-600 hover:underline"
            >
              Reset
            </button>
          </p>
        </form>

      </div>
    </div>
  );
};

export default Login;
